export default __webpack_public_path__ + "static/media/ransomware.d5837f1e.png";